import { useState, useContext } from 'react';
import { ModalContext, AppContext, EMPTY_OBJECT } from 'commons-ui';

import { IUseRejectProps } from '../../types';
import useService from '../../utils/useService';

const useReject = (confiscationId: string, fetchConfiscationAndRefundData: () => void) => {
	const { showAlert } = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);
	const { setModalConfig } = useContext(ModalContext);
	const { updateConfiscationAndRefundRequest } = useService();

	const handleFormSubmit = async (formData: IUseRejectProps) => {
		setModalConfig({ isOpen: false });
		setShowLoader(true);
		try {
			await updateConfiscationAndRefundRequest({
				confiscationId,
				...formData,
				isApproved: false
			});
			await fetchConfiscationAndRefundData();
			showAlert('Confiscation request rejected sucessfully!', { type: 'success' });
			setShowLoader(false);
		} catch (e: any) {
			showAlert(e.response?.data?.error ?? 'Error while rejecting the confiscation request', { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useReject;
